export const roundNumber = (num: number, decimals = 6): number => {
  const n = num.toFixed(decimals);
  return parseFloat(n);
};
